import { getAccentColorForStroke } from '../../../../../common/utils/contrast-color';
import type { TagColor } from '../types';
type TagColorResult = {
  tagBackground?: string;
  tagTextColor?: string;
  hierarchy: 'primary' | 'secondary';
};
export const getTagColors = ({
  tagColor,
  isExpanded
}: {
  tagColor?: TagColor;
  isExpanded: boolean;
}): TagColorResult => {
  if (!tagColor) {
    return {
      hierarchy: isExpanded ? 'primary' : 'secondary'
    };
  }
  if (isExpanded) {
    return {
      hierarchy: 'primary',
      tagBackground: tagColor.primary,
      tagTextColor: tagColor.tertiary ?? getAccentColorForStroke(tagColor.primary)
    };
  }
  const tagBackground = tagColor.secondary ?? tagColor.primary;
  return {
    hierarchy: 'secondary',
    tagBackground,
    tagTextColor: tagColor.secondary ? tagColor.primary : getAccentColorForStroke(tagBackground)
  };
};